export default "__VITE_ASSET__9V78TRTX__"